import React from 'react';
import './GlassCard.css';

export const GlassCard = ({
    children,
    className = '',
    style = {},
    onClick,
    ...props
}) => {
    return (
        <div
            className={`glass-card ${className}`}
            style={style}
            onClick={onClick}
            {...props}
        >
            {children}
        </div>
    );
};

export default GlassCard;
